module.exports = __webpack_public_path__ + "static/img/MI.e5b683d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/listings/states/MI.jpg
// module id = 9n+v
// module chunks = 0